import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import MuiDatePicker, {
  DatePickerProps,
  InlineDatePicker as MuiInlineDatePicker,
} from 'material-ui-pickers/DatePicker'

import { Moment } from 'moment'

import { memoize } from '../../utils'

const genOnDateChange = memoize(
  (name: string) =>
    handleChange =>
      (moment: Moment) => {
        handleChange({
          target: {
            name,
            value: moment.valueOf(),
          }
        })
      }
)

interface EnhancedDatePickerProps extends DatePickerProps {
  name: string
  value: number
}

const DateTimePicker = (props: EnhancedDatePickerProps) => (
  <MuiDatePicker
    {...props}
    onChange={genOnDateChange(props.name)(props.onChange)}
    invalidLabel={''}
    label={<FormattedMessage id={'labels.' + props.label} />}
  />
)

export const InlineDatePicker = (props: EnhancedDatePickerProps) => (
  <MuiInlineDatePicker
    {...props}
    keyboard
    mask={[ /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/ ]}
    onChange={genOnDateChange(props.name)(props.onChange)}
    invalidLabel={''}
    label={<FormattedMessage id={'labels.' + props.label} />}
    helperText={
      props.helperText
      && props.error
      && <FormattedMessage id={'validation.' + props.helperText} />
    }
  />
)

export default DateTimePicker



// WEBPACK FOOTER //
// ./src/components/atoms/DatePicker.tsx